document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".featuredProductContainer");

  sections.forEach((section) => {
    const container = section.querySelector(".slidingComponent");
    const innerWidth = container.getBoundingClientRect().width;
    const scrollWidth = container.scrollWidth;
    // console.log(att)
    let autoplayd = section.getAttribute('autoplay') === 'true'? true : false;
    let stopAutoScrolling = false;
    let slidingComponentPosition = 0;
    function isPhoneViewport() {
      return window.innerWidth <= 768; 
    }
    let autoplay = isPhoneViewport() ? false : true;
    const updateButtonStates = () => {
      const slidePrevious = section.querySelector(".slidePrevious");
      const slidenext = section.querySelector(".slidenext");

      if (slidePrevious && slidenext) {
        slidePrevious.disabled = slidingComponentPosition <= 0;
        slidenext.disabled =
          slidingComponentPosition >= scrollWidth - innerWidth;
      }
    };

    const startScrolling = () => {
      setInterval(() => {
        if (!stopAutoScrolling && autoplay && autoplayd) {
          if (scrollWidth >= slidingComponentPosition) {
            slidingComponentPosition = slidingComponentPosition + innerWidth;
            container.scrollLeft = slidingComponentPosition;
          } else {
            slidingComponentPosition = 0;
            container.scroll(0, 0);
          }
        }
      }, 5000);
    };

    startScrolling();
    updateButtonStates();

    const addScrollEventListener = () => {
      container.addEventListener("scroll", () => {
        slidingComponentPosition = container.scrollLeft;
        updateButtonStates();
      });
    };

    const removeScrollEventListener = () => {
      container.removeEventListener("scroll", () => {
        slidingComponentPosition = container.scrollLeft;
        updateButtonStates();
      });
    };
    const slidePrevious = section.querySelector(".slidePrevious");
    const slidenext = section.querySelector(".slidenext");
    const showbuttons = () => {
      slidePrevious.style.visibility = "visible";
      slidenext.style.visibility = "visible";
    };
    const hideButton = () => {
      slidePrevious.style.visibility = "hidden";
      slidenext.style.visibility = "hidden";
    };

    section.addEventListener("mouseover", () => {
      addScrollEventListener();
      stopAutoScrolling = true;
      showbuttons();

      section.addEventListener("mouseout", () => {
        removeScrollEventListener();
        stopAutoScrolling = false;
        hideButton();
        controlAutoScrolling();
      });
    });
    function controlAutoScrolling() {
      stopAutoScrolling = true;
    }
    
    

    if (slidePrevious && slidenext) {
      slidePrevious.addEventListener("click", () => {
        if (slidingComponentPosition > 0) {
          slidingComponentPosition = slidingComponentPosition - innerWidth;
          container.scrollLeft = slidingComponentPosition;
          controlAutoScrolling();
        }
      });

      slidenext.addEventListener("click", () => {
        if (slidingComponentPosition < scrollWidth - innerWidth) {
          slidingComponentPosition = slidingComponentPosition + innerWidth;
          container.scrollLeft = slidingComponentPosition;
          controlAutoScrolling();
        }
      });
    }
  });
});

const GetScrollDirection = (lastScroll, CurrentScroll)=>{
  if(lastScroll > CurrentScroll){
    const ScrollDirection = "LEFT"
    return "LEFT";
  }else{
    return "RIGHT";
  }
}

const handleLeftScrollInFeaturedCollection = (scrollLeft, scrollWidth, containerWidth, container) =>{
const children = Array.from(container.children);
  const removedChildren = children.splice(-6);
  if(scrollLeft < container.clientWidth){
    removedChildren.reverse(); 
    removedChildren.forEach((child) => {
      container.insertBefore(child, container.firstChild);
    });

  }  
}

const handleRightScrollInFeaturedCollection = (scrollLeft, scrollWidth, containerWidth, container) =>{
  const ScrollLeft = scrollLeft + containerWidth;
  const ScrollRight = scrollWidth - ScrollLeft;
  const children = Array.from(container.children);
  const removedChildren = children.splice(0, 6);
  if(ScrollRight < container.clientWidth){
    removedChildren.forEach((child) => {
      container.appendChild(child);
    });
  }
}

const infiniteScrollerForFeaturedCollection = (e) =>{
  const container = e.querySelector(".slidingComponent");
  let LastScroll = container.scrollLeft;
  container.addEventListener("scroll", (event)=>{
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const ContainerWidth = e.clientWidth;
    const ScrollDirection = GetScrollDirection(LastScroll, scrollLeft);
    if(ScrollDirection === "LEFT"){
      handleLeftScrollInFeaturedCollection(scrollLeft, scrollWidth, ContainerWidth, container);
      }else if(ScrollDirection === "RIGHT"){
      handleRightScrollInFeaturedCollection(scrollLeft, scrollWidth, ContainerWidth, container);
      }
    LastScroll = scrollLeft;
  });
}
document.addEventListener("DOMContentLoaded", () =>{
  const sections = document.querySelectorAll(".featuredProductContainer");
  sections.forEach((e)=>{
    infiniteScrollerForFeaturedCollection(e);
  })
})





